import { useTransition, animated } from "@react-spring/web";

type SlideUpTransitionProps = {
  show: boolean;
  children: React.ReactNode;
  className?: string;
};

export const SlideUpTransition = ({
  show,
  children,
  className
}: SlideUpTransitionProps) => {
  const transitions = useTransition(show, {
    from: { opacity: 0, transform: "translateY(100%)" },
    enter: { opacity: 1, transform: "translateY(0%)" },
    leave: { opacity: 0, transform: "translateY(100%)" },
    config: { tension: 300, friction: 30 }
  });

  return (
    <>
      {transitions((style, item) =>
        item ? (
          <animated.div style={style} className={className}>
            {children}
          </animated.div>
        ) : null
      )}
    </>
  );
};
